export const sampleConstants = {
    SAVE_MY_EMAIL: 'SAVE_MY_EMAIL',
    SAVE_DOB: 'SAVE_DOB',
}